import * as React from 'react';
import * as styles from '../../Permissions.css';
import { IAIcon } from '../../../icon/Icon';
import { LocalizationService } from '../../../../services/LocalizationService';

export interface IPermissionSwitchProps {
  selectedOption: { title: string, key: string };
  selectOption: (selectOption: string) => void;
}

export interface IPermissionSwitchState {
  showPermissionsBox: boolean;
  options: { title: string, key: string }[];
}

export class PermissionSwitch extends React.Component<IPermissionSwitchProps, IPermissionSwitchState> {
  
  private localizationService: LocalizationService = new LocalizationService();

  constructor(props: IPermissionSwitchProps) {
    super(props);
    this.state = {
      showPermissionsBox: false,
      options: [
        {
          title: this.localizationService.strings.Permissions_Owner,
          key: "Administrator"
        },
        {
          title: this.localizationService.strings.Permissions_Member,
          key: "Editor"
        },
        {
          title: this.localizationService.strings.Permissions_Reader,
          key: "Reader"
        },
        {
          title: this.localizationService.strings.Permissions_Remove,
          key: "Remove"
        }
      ]
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public render(): JSX.Element {
    const options = [];
    this.state.options.forEach((option: {title: string, key: string}) => {
      if (option.key !== this.props.selectedOption.key) {
        options.push(
          <div
            className={styles.IA_permissionSwitchBoxButton}
            onClick={() => {
              this.props.selectOption(option.key);
              this.setState({
                showPermissionsBox: !this.state.showPermissionsBox
              });
            }}
          >
            {option.title}
          </div>
        );
      }
    });
    return (
      <div className={styles.IA_permissionSwitch}>
        <div className={styles.IA_permissionSwitchLabel}>
          {this.props.selectedOption.title}
        </div>
        <IAIcon
         url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg"
          size={16}
          color={"#777777"}
          style={{
            float: "left",
            marginLeft: 5,
            cursor: "pointer"
          }}
          onClick={() => {
            this.setState({
              showPermissionsBox: !this.state.showPermissionsBox
            });
          }}
        />
        <div
          className={styles.IA_permissionSwitchBox}
          style={{
            display: this.state.showPermissionsBox ? "block" : "none"
          }}
        >
          {options}
        </div>
      </div>
    );
  }

  
}